import React from "react";
import { InputLabel } from "@mui/material";

const InputLabelCustom = (props) => {
  const { htmlFor, text } = props;
  return (
    <InputLabel
      {...props}
      htmlFor={htmlFor}
      sx={{
        textOverflow: "clip",
        whiteSpace: "nowrap",
        overflow: "hidden",
        display: "block",
        width: "100%",
        marginBottom: "5px",
        fontSize: "13px",
      }}
    >
      {text}
    </InputLabel>
  );
};

export default InputLabelCustom;
